/*jshint esversion: 6 */
// Rows of empty "0.0 (0)" stars on product grids read as unpopular products, so hide Bazaarvoice inline
// ratings for products with no reviews. BV renders after the page loads (and search results are rendered
// client-side), so watch the page for its markup. BV's markup is the same with or without reviews apart
// from the review count text, so that's what's checked.
export default (function () {
    if (!('MutationObserver' in window)) {
        return;
    }

    let scheduled = false;

    function markEmptyRatings() {
        scheduled = false;

        [].slice.apply(document.querySelectorAll('[data-bv-show="inline_rating"]:not(.bv-inline-rating--checked)')).forEach(rating => {
            const count = rating.querySelector('.bv_numReviews_component_container .bv_text');

            // Not rendered by BV yet - check again on the next change
            if (!count) {
                return;
            }

            rating.classList.add('bv-inline-rating--checked');

            if (count.textContent.trim() === '(0)') {
                rating.classList.add('bv-inline-rating--empty');
            }
        });
    }

    new MutationObserver(() => {
        if (!scheduled) {
            scheduled = true;
            window.requestAnimationFrame(markEmptyRatings);
        }
    }).observe(document.documentElement, { childList: true, subtree: true });
})();
